import type { ProviderKind } from '@pipi/shared';
import { CheckCircle2, Filter, Music4 } from 'lucide-react';
import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { SongGrid } from '../components/song-grid';
import { useCatalog } from '../hooks/use-catalog';
import { useAppState } from '../state/app-state';

export function LibraryPage() {
  const { data } = useAppState();
  const [searchParams] = useSearchParams();
  const [provider, setProvider] = useState<ProviderKind | 'all'>((searchParams.get('provider') as ProviderKind | null) ?? 'all');
  const [genre, setGenre] = useState('');
  const [onlyPlayable, setOnlyPlayable] = useState(true);
  const query = useMemo(() => ({ provider, genre, capability: onlyPlayable ? 'playable' as const : undefined, limit: 120 }), [provider, genre, onlyPlayable]);
  const { page, loading } = useCatalog(query);
  if (!data) return null;

  return (
    <div className="library-page">
      <section className="library-toolbar">
        <div className="provider-tabs">
          <button type="button" data-tv-focusable className={provider === 'all' ? 'is-active' : ''} onClick={() => setProvider('all')}>
            <Music4 size={20} />全部 <span>{data.providers.reduce((total, item) => total + item.songCount, 0).toLocaleString()}</span>
          </button>
          {data.providers.filter((item) => item.songCount > 0).map((item) => (
            <button type="button" data-tv-focusable key={item.id} className={provider === item.kind ? 'is-active' : ''} onClick={() => setProvider(item.kind)}>
              {item.name}<span>{item.songCount.toLocaleString()}</span>
            </button>
          ))}
        </div>
        <button type="button" data-tv-focusable className={onlyPlayable ? 'playable-toggle is-active' : 'playable-toggle'} onClick={() => setOnlyPlayable((value) => !value)}>
          <CheckCircle2 size={20} />只看能唱
        </button>
      </section>
      <section className="filter-row">
        <span><Filter size={19} />曲风</span>
        <button type="button" data-tv-focusable className={!genre ? 'filter-chip is-active' : 'filter-chip'} onClick={() => setGenre('')}>全部</button>
        {(page?.facets.genres ?? []).slice(0, 10).map((facet) => (
          <button type="button" data-tv-focusable key={facet.key} className={genre === facet.key ? 'filter-chip is-active' : 'filter-chip'} onClick={() => setGenre(facet.key)}>
            {facet.key}<small>{facet.count}</small>
          </button>
        ))}
      </section>
      <header className="results-heading">
        <div><span className="eyebrow">UNIFIED LIBRARY</span><h2>所有能唱的歌，都在这里</h2></div>
        <strong>{loading ? '整理中…' : `${page?.total.toLocaleString() ?? 0} 首`}</strong>
      </header>
      <SongGrid songs={page?.items ?? []} loading={loading} />
    </div>
  );
}
